import React, { Component } from "react";

class Kurser extends Component {
  render() {
    return (

<center>
  <div className="info" style={{ textAlign: "left" }}>
    <center>
      <h1>
        Kurser på folkmusikkaféet
        <br />
        Hösten 2025
      </h1>
    </center>
    <br />

    <center>
      <h3>Spelmanslaget</h3>
      <img
        className="kursbild-mindre fade-in-fast"
        style={{ paddingRight: "40px" }}
        src="img/arkiv/jon_olov.jpg"
      />
      <img
        className="kursbild-mindre fade-in-fast"
        src="img/arkiv/dan_palmqvist_small.jpg"
      />
    </center>
    <center>
      <div className="kompakt">
        Kursen hålls fredagar kl 17:30 – 19:15 med start 19 september och omfattar hela hösten och
        alla med akustiska instrument är välkomna. Vi ser gärna att du har något eller några års
        erfarenhet på ditt instrument. Som kompmusiker ser vi helst att du är relativt självständig
        och kan lite grunder i folkmusik.
        <br />
        <br />
        Kursinstruktör: Jon-Olov Woxlin och Dan Palmqvist
        <br />
        <br />
        Kostnad: 600 kr (ung & stud. 350 kr) betalas in på pg 107741–1 eller Swish 1236085450.
        Ange namn + ”spelmanslaget”.
        <br />
        <br />
        <small>
          Information: Dan Palmqvist, <a href="mailto:dan.palmqst@gmail.com">dan.palmqst@gmail.com</a>
        </small>
      </div>
    </center>
    <br />

    <center>
      <h3>Nybörjarkurs i dans till folkmusik</h3>
    </center>
    <br/>
    <center><img style={{width:"40%", borderRadius: "10px"}} src="img/program/ht2025/danskurs-min.jpg"></img></center>
    <br/>
    <center>
      <small>
        Sju fredagskvällar med start 26/9 och avslutning 14/11 (ej 31/10).
      </small>
      <br />
      <br />
      <div className="kompakt">
        Välkomna till en nybörjarkurs med grunderna i schottis, vals och några polskor. Vi lär ut
        grundläggande danser som är användbara på Folkmusikkaféet, spelmansstämmor och liknande
        arrangemang med dans till folkmusik. Kursen riktar sig till rena nybörjare och er som dansat
        förut men känner att en riktig grundkurs skulle göra gott. Exempel på kursinnehåll kan vara
        schottis, vals, ”rundpolska”, slängpolska, trisspolska och tillhörande dansteknik.
        <br />
        <br />
        Medtag skor som har sulor ”med glid”.
        <br />
        <br />
        Kursinstruktörer: Ingela och Håkan Lindberg
        <br />
        Spelman: Björn Johnsson
        <br />
        <br />
        Tider: Fredagskvällar 18:00 – 19:30.
        <br />
        Kursavgift: 600 kr (ung & stud 300 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. <br />
        <b>Länk till anmälan:</b> <a href="https://www.bilda.nu/arr/1266996/nyborjarkurs-i-dans-till-folkmusik-927569">Klicka här</a>.
        <br />
        <br />
        Frågor: Håkan Lindberg, tel. 0767–133250 eller{" "}
        <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>
      </div>
    </center>
    <br />



    <center>
      <h3>Folklig sång med Ulrika Bodén</h3>
    </center>
    <center><img style={{width:"40%", borderRadius: "10px"}} src="img/program/ht2025/ulrikaboden.jpg"></img></center>
    <br/>
    <center>
      <div className="kompakt">
        Möt folksångerskan Ulrika Bodén under en kursdag då hon delar med sig av vackra och roliga
        visor ur sin stora repertoar. Efter en skön uppvärmning av kropp och röst lärs
        kärlekssånger, vallvisor, polsketrall och berättande visor ut på gehör. Flera av sångerna
        kommer från Ulrikas hemtrakter i Ångermanland. Ulrika ger också nycklar in till den
        folkliga sångstilen i form av klang, drillar, rytmik och blåtoner, kopplade till visorna du
        lär dig.
        <br />
        <br />
        Kursledare: Ulrika Bodén
        <br />
        Tid: Lördag 15/11 kl 10:00 – 16:00
        <br />
        Plats: Gräfsnäsgårdens annex
        <br />
        Kursavgift: 450 kr (ung & stud 250 kr).
        <br />
        <br />
        Kursen arrangeras i samarbete med Bilda. <br />
        Kursanmälan görs senast 1/11. <br/><b>Länk till anmälan:</b> <a href="https://www.bilda.nu/arr/1261002/kurs-i-folklig-sang-med-ulrika-boden-927103">Klicka här</a>
        <br />
        <br />
        Frågor: <a href="mailto:kurser@folkmusikkafeet.net">kurser@folkmusikkafeet.net</a>, tel. 070332781 (Lars-Gunnar Franzén)
        <br />
        <br />
        <i>Kursdeltagare erhåller 50 % rabatt på konsertkvällar under kursen (kan ej kombineras med andra rabatter).</i>
      </div>
    </center>
    <br />

    <center>
      <h3>Tillsammansgruppen</h3>
      <img className="kursbild fade-in-fast" src="img/tillsammansgruppen.jpg" />
    </center>
    <center>
      <div className="kompakt">
        Genom alla tider har vi lekt på fest och till vardags, barn som vuxen. Tillsammansgruppen
        ger dig möjlighet att ta del av denna roliga tradition.
        <br />
        Stora som små är varmt välkomna att hänga med i vindlande långdanser och visor.
        <br />
        Det är motion för både kropp som knopp!
        <br />
        <br />
        Tider: 18:00 – 19:30 med tid för fika.
        <br />
        Datum: 26/9, 17/10 och 28/11
        <br />
        Instruktörer: Gunnel Sjögren och Gunilla Sellersjö
        <br />
        <br />
        Kostnad: Gratis för barn i sällskap med någon vuxen.
      </div>
    </center>
    <br />
    <br />

    <center>
      <small>Folkmusikkaféet samarbetar med och stöds av:</small>
    </center>
  </div>
</center>
    );
  }
}

export default Kurser;
